import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import { Row, Col, Card, Table } from "react-bootstrap";

const Appointments = () => {

  const [appointments, setAppointments] = useState([]);

  useEffect(() => {
    fetch("https://admin.drgargevascular.com/backend/appointments")
      .then(res => res.json())
      .then(data => setAppointments(data))
      .catch(err => console.log(err));
  }, []);

  return (
    <Fragment>
      <PageTitle activeMenu="Appointments" motherMenu="Dashboard" />

      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>Appointments List</Card.Title>
            </Card.Header>

            <Card.Body>
              <Table responsive className="table-bordered table-striped">
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Full Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Service</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Message</th>
                  </tr>
                </thead>

                <tbody>
                  {appointments.length > 0 ? (
                    appointments.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.full_name}</td>
                        <td>{item.email}</td>
                        <td>{item.phone_number}</td>
                        <td>{item.services}</td>
                        <td>{item.date}</td>
                        <td>{item.time}</td>
                        <td>{item.message}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No Appointments Found
                      </td>
                    </tr>
                  )}
                </tbody>

              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Appointments;